const { Directus } = require("@directus/sdk");
const directus = new Directus("https://api.inzicht-heerlen.nl");

export default directus;
